(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-form"] && !Shopify.designMode) return;
  try {
    
    console.log("Dynamic Form XD - complete upload v1.0.30g -");

    $(function() {
        console.log("Dynamic Form numbers");
        console.log("template page", template);
        if(template == "page.register"){
            sendDataLayer({"eventType": "start-register-form", "step": "1"});
        } else if (template == "page.register2"){
            sendDataLayer({"eventType": "start-register-form", "step": "2"});
        } else if(template == "page.sales-advice"){
            sendDataLayer({"eventType": "start-sales-advice-form"});
        } else if(template == "page.customer-services"){
            sendDataLayer({"eventType": "start-customer-service-form"});
        }

        $(".dropzone").each(function() {
            var id = $(this).attr("id");
            var idHidden = $(this).attr("data-field-hidden");
            var templateId = $(this).attr("data-preview-template");
            var previewId = $(this).attr("data-preview");
            var dataRequired = $(this).attr("data-required");
            dropzones_validation.push({ "id": id, "required": dataRequired});
            initDropZone("#" + id, "#" + idHidden, "#" + templateId, "#" + previewId); 
        });

        if($('.sap_country').length > 0){
            initSapCountrySelect();
        }

        console.log("subform one more time x7...");
        $(".subform-el").each(function() {
            var subform = $(this).attr("data-subform");
            console.log("subform", subform);
            var identifier = Date.now();
            var html = $("#subform-" + subform + " .subform").html();
            html = html.replace("row_identifier",identifier);

            $("#subform-element-" + subform).append(html);

            $("#add-" + subform).click(function () {
                var subform = $(this).attr("data-subform");
                 var identifier = Date.now();
                var html = "<hr id='hr" + identifier + "'>";
                html += $("#subform-" + subform + " .subform").html();
                html = html.replace("row_identifier", identifier);
                $("#subform-element-" + subform).append(html);
                
            });
        });

        if($('.phone-numb').length > 0){
            /*
            var input = document.querySelector(".phone-numb");
            window.intlTelInput(input, {
              // any initialisation options go here
              utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js"
            });
            */
            var elements = document.querySelectorAll('.phone-numb');

            // Loop through each element and initialize intlTelInput
            for (var i = 0; i < elements.length; i++) {
              var iti = window.intlTelInput(elements[i], {
                utilsScript: "https://cdn.shopify.com/s/files/1/0548/9511/6369/files/utils.js?v=1692886558"
                //https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js"
              });

              itis[elements[i].id] = iti;
                  
              
            }
        }

        $('body').on('click','.delete-subform',function(e){
            var subform = $(this).closest("form").attr("id");
            console.log('.delete-subform', subform);
            $("#" + subform).remove();
            $("#hr" + subform).remove();
        });

        tippy('.delete-subform', {
          content: 'Delete item!',
        });

        $(document).on('change', '.multiple-other', function() {
            var input_id = $(this).attr("data-input");
            
            if(this.checked) {
                $("#" + input_id).show();
            } else {
                $("#" + input_id).hide();
            }
        });

        const inputs = document.querySelectorAll('.money_field');

        inputs.forEach(function(input) {
          const value = input.value.replace(/\D/g, '');
          const formattedValue = `USD $${parseInt(value).toLocaleString()}`;
          input.value = formattedValue;
          
          input.addEventListener('input', function(e) {
            // Remove non-digit characters from the input
            const value = e.target.value.replace(/\D/g, '');
          
            // Format the input with a dollar sign and text
            const formattedValue = `USD $${parseInt(value).toLocaleString()}`;
          
            // Update the input value
            e.target.value = formattedValue;
          });
        });

        $(document).on('click', '#send', function(){
            sendFormToWCX();
        });

        $.applyDataMask();

        prefillFields();

        /*
        $(".datepicker").each(function() {
            var id = $(this).attr("id");
            $("#" + id).datepicker();
        });
        
        $('body').on('focus',".datepicker", function(){
            $(this).datepicker();
        });
        */
        //$(".datepicker").datepicker();
        $('body').on('click','.datepicker', function() {
            $(this).datepicker('destroy').datepicker({showOn:'focus'}).focus();
        });

        if(show_embeded){
            console.log("show_embeded");
            var element = $("#" + section_id).detach();
            $("#" + embeded_element_id).append(element);
            $("#" + section_id).show();
            
        }
    });

    function sendFormToWCX(){
        
            //console.log("getAcceptedFiles()");
            //console.log(myDropzone.getAcceptedFiles());
            var isValid = validateFrm("#contact_form_dynamic .required");
            var isValidCheckbox = validateFrmCheckebox("#contact_form_dynamic .requiredChk");
            var isValidPhoneNumbers = validatePhoneNumber(".phone-numb");
            var isValidNumbers = validateNumberField(".number_field");
            console.log("dropzones_validation", dropzones_validation);
            if(dropzones.length > 0){

                for(var j = 0; j < dropzones.length; j++){

                    myDropzone = dropzones[j];
                    var getAcceptedFiles = [];
                    console.log("myDropzone", myDropzone.element.id);
                    var getRejectedFiles = myDropzone.getRejectedFiles();
                    console.log("getRejectedFiles");
                    console.log(getRejectedFiles);
        
                    if(getRejectedFiles.length > 0){
                        isValid = false;
                        $("#warnings span").text("Maximum file size is 4MB.");
                        $("#warnings").show();
                    } else {
                        getAcceptedFiles = myDropzone.getAcceptedFiles();
                        console.log("getAcceptedFiles");
                        console.log(getAcceptedFiles);
        
                        var totalBytes = 0;
                        for(var i = 0; i < getAcceptedFiles.length; i++){
                            var file = getAcceptedFiles[i];
            
                            totalBytes += (file.upload.total / 1024 / 1024).toFixed(1);
                        }
            
                        if(totalBytes > 5){
                            isValid = false;
                            $("#warnings span").text("Sum of the files sent in the same request must not exceed 4MB.");
                            $("#warnings").show();
                        }
                    }

                    var dropzone_valid = dropzones_validation.find(item => item.id === myDropzone.element.id);

                    if(dropzone_valid.required == "true" && getAcceptedFiles.length == 0){
                        isValid = false;
                        $("#warnings span").text("You must provide at least one file.");
                        $("#warnings").show();
                        $("#" + myDropzone.element.id).addClass("error-dropzone");
                    } else {
                        $("#" + myDropzone.element.id).removeClass("error-dropzone");
                    }

                }  
            }
            
            if(isValid && isValidCheckbox && isValidPhoneNumbers && isValidNumbers){
                showLoading();
                //var subject = $("#subject").val() != 'Otro'? $("#subject").val(): $("#other_subject").val();
                var body = '';
                var attachments = [];

                body += '<table><tr><td style="border: 1px solid #000; padding: 5px">Date</td><td style="border: 1px solid #000; padding: 5px;">' + new Date().toLocaleString() + '</td></tr>';
                body += '<tr><td style="border: 1px solid #000; padding: 5px">Language</td><td style="border: 1px solid #000; padding: 5px;">' + language + '</td></tr>';

                $('#contact_form_dynamic .fld').each(function(){
                    if($(this).css('display') != 'none'){
                        var name = $(this).attr('data-name');
                        var val = $(this).val();

                        if($(this).hasClass("phone-numb")){
                            var id = $(this).attr("id");
                            var input = document.querySelector('#' + id);
                            //var iti = window.intlTelInputGlobals.getInstance(input);
                            var iti = itis[id];
                            val = iti.getNumber();
                        }

                        body += '<tr><td style="border: 1px solid #000; padding: 5px">' + name + '</td><td style="border: 1px solid #000; padding: 5px;">' + val + '</td></tr>';
                        subject = subject.replace("#" + name.toLowerCase() + "#", val);
                    }
                });
               
              
                $(".multiple_options").each(function(){
                    var name = $(this).attr("data-name");
                    var id_opt = $(this).attr("data-multiple");
                    var values = '';
                    $('.' + id_opt +':checked').each(function(){ 
                        if (values != '') {
                            values += ', ';
                        }
                        if($(this).val() == "other_opt"){
                            var input_id = $(this).attr("data-input");
                            values += $("#" + input_id).val();
                        } else {
                          values += $(this).val();
                        }
                    });

                    body += '<tr><td style="border: 1px solid #000; padding: 5px">' + name + '</td><td style="border: 1px solid #000; padding: 5px;">' + values + '</td></tr>';
                });

                body += '</table>';

                var table = "";
                $(".subform-el").each(function() {
                    var subform = $(this).attr("data-subform");
                    var thead = "";
                    $('.contact-form-' + subform).each(function(){
                        var subform_row_id = $(this).attr("id");
                        
                        var trow = "";
                        $("#" + subform_row_id + " .field-subform-" +subform).each(function(){
                            var name = $(this).attr('data-name');
                            var val = $(this).val();
                            thead += "<th style='padding: 0 10px'>" + name + "</th>";
                            trow += "<td style='padding: 0 10px'>" + val + "</td>";
                        });
                        
                        if(!table.includes("thead")){
                            table = "<table><thead><tr>" + thead + "</tr></thead>"
                            table += "<tbody>"
                        }

                        table += "<tr>" + trow + "</tr>";
                        

                        /*
                        if($(this).css('display') != 'none'){
                            var name = $(this).attr('data-name');
                            var val = $(this).val();

                            body += name + ": " + val + "<br>";
                        }*/
                    });
                });
                
                if(table.length > 0){
                    table += "</tbody></table>";
                    body += "<br>" + table;
                }
            
                /*
                $('#contact_form_dynamic .fld-file').each(function(){
                    var attachment = {
                        content: $(this).val(),
                        filename: $(this).attr("data-filename")
                    };

                    attachments.push(attachment);
                });*/
              
                if(dropzones.length > 0){

                    for(var j = 0; j < dropzones.length; j++){

                        myDropzone = dropzones[j];
                          
                        var files = myDropzone.getAcceptedFiles();
                        console.log("files");
                        console.log(files);
                        for(var i = 0; i < files.length; i++){
                            var item = files[i];
                            var result =  files_to_upload.filter(function(f) {
                              return f.uuid == item.upload.uuid;
                            });
                            var file = result[0];
                           
                            var attachment = {
                                content: file.dataUrl,
                                filename: item.name,
                            };
        
                            attachments.push(attachment);
                        }
                    }
                }

                subject = subject + " " + language;
                var wrapper = {
                    group_id: group_id,
                    subject: subject,
                    contact_email: $("input[name='contact-email']").val(),
                    contact_name: $("input[name='contact-firstname']").val() + " " + $("input[name='contact-lastname']").val(),
                    body: body,
                    attachments: attachments
                };

                var company_name = $("input[name='company-name']").val();

                console.log("Wrapper", wrapper);

                if(template == "page.register"){
                    fetch('https://distritech-3f2e5c33550b.herokuapp.com/api/validatebusinesspartner?email=' + wrapper.contact_email + '&cardname=' + company_name)
                      .then(response => response.json())
                      .then(data => {
                          console.log("data validation", data);

                          if(data == null || data == 0){
                             var inputPhone = document.querySelector('[name="mobile-phone"]');
                             var iti = itis[inputPhone.id];
                             //var iti = window.intlTelInputGlobals.getInstance(inputPhone);
                             var numb = iti.getNumber();
                             //var numb = $("input[name='mobile-phone'").val();
                            
                              var bp = {
                                  CardType: "cLid",
                                  CardName: $("input[name='company-name']").val(),
                                  GroupCode: $("select[name='company-base-country']").val(),
                                  EmailAddress: wrapper.contact_email,
                                  ContactPerson: wrapper.contact_name,
                                  Cellular: numb,
                                  Industry: $("select[name='type-of-bussiness']").val(),
                                  Website: $("input[name='company-website']").val(),
                                  Notes: "eCommerce created on " + new Date().toLocaleString(),
                                  //Country: $("select[name='company-base-country']").val(),
                                  //OwnerCode: "173",
                                  //SlpCode: "133",
                                  FreeText:  "eComm Created on " + new Date().toLocaleString(),
                                  U_DST_Number_Emp: $("input[name='number-of-employees']").val(),
                                  U_DST_Year_Est: $("select[name='year-established']").val(),
                                  U_DST_Category_Interest: getValueFromMultioptions("#opts-84e4f462-0eb9-403f-9562-b1de611f08ea"),
                                  U_DST_Commu_Channel: getValueFromMultioptions("#opts-af2b8cb9-b5fb-45f3-abb8-c1253ea820f6"),
                                  U_DST_Date: new Date().toISOString(),
                                  U_DST_Status: "New Lead Registered",
                                  U_DST_Source: "Website",
                                  ContactEmployees:[
                                      {
                                        Name: $("input[name='contact-firstname']").val() + " " + $("input[name='contact-lastname']").val(),
                                        FirstName: $("input[name='contact-firstname']").val(),
                                        LastName: $("input[name='contact-lastname']").val(),
                                        E_Mail: wrapper.contact_email,
                                        MobilePhone: numb,
                                        Position: $("select[name='please-select-the-best-description-for-your-current-role-position-title']").val(),
                                        Remarks1: "Default eCom Contact",
                                        U_eCommerceAccount: '1',
                                        U_eCommerceAdmin: 'Y'
                                      }
                                  ]
                              };

                              var myHeaders = new Headers();
                              myHeaders.append("Content-Type", "application/json");
                                
                              var raw = JSON.stringify(bp);
                            
                              var requestOptions = {
                                method: 'POST',
                                headers: myHeaders,
                                body: raw
                              };
                              
                              fetch("https://distritech-3f2e5c33550b.herokuapp.com/api/createbusinesspartner", requestOptions)
                                .then(response => response.json())
                                .then(result => {
                                    console.log(result);
                                    console.log("CardCode", result.CardCode);

                                    wrapper.body = wrapper.body + "<br><br>CardCode: <b>" + result.CardCode + "</b>";
                                    createWcxCase(wrapper);
                                    //location.reload();
                                })
                                .catch(error => console.log('error', error));
                              
                          } else {
                              hideLoading();
                              Swal.fire({
                                  icon: 'error',
                                  title: 'Oops...',
                                  text: "We have found a similar customer record in our database, if you are already a customer of Distritech there is no need to complete this registration form, please contact your account executive or submit a case trough our customer service portal." 
                              });
                          }
                      });

                } else if(template == "page.register2"){

                    var formsData = [];

                    var formsDiv = document.getElementById('subform-element-PurchaserContact');
                    
                    var forms = formsDiv.querySelectorAll('form');
                    
                    for (var i = 0; i < forms.length; i++) {
                      // Obtener los campos del formulario actual
                      var name = forms[i].querySelector('input[name="contact-name"]').value;
                      var email = forms[i].querySelector('input[name="contact-email"]').value;
                      var phone = forms[i].querySelector('input[name="authorized-purchaser-mobile-phone"]').value;
                    
                      var formData = {
                        Name: name,
                        E_Mail: email,
                        MobilePhone: phone,
                        Position: "Buyer",
                        U_eCommerceAccount: '1',
                        U_eCommerceAdmin: 'N'
                      };
                    
                      formsData.push(formData);
                    }

                    formsDiv = document.getElementById('subform-element-AccountsContacts');
                    
                    forms = formsDiv.querySelectorAll('form');
                    
                    for (var i = 0; i < forms.length; i++) {
                      // Obtener los campos del formulario actual
                      var name = forms[i].querySelector('input[name="contact-name"]').value;
                      var email = forms[i].querySelector('input[name="contact-email"]').value;
                      var phone = forms[i].querySelector('input[name="mobile-phone-accounts-payable-contact"]').value;
                    
                      var formData = {
                        Name: name,
                        E_Mail: email,
                        MobilePhone: phone,
                        Position: "Accounts Payable",
                        U_eCommerceAccount: '1',
                        U_eCommerceAdmin: 'N'
                      };
                    
                      formsData.push(formData);
                    }
                    
                    // Imprimir el arreglo con los objetos JSON en la consola
                    console.log(formsData);

                    var billingAddr = {
                        AddressName: "Default Billing Address",
                        Street: $("input[name='street-address']").val() + ' ' + $("input[name='street-address-2']").val(),
                        ZipCode: $("input[name='zipcode']").val(),
                        City: $("input[name='city']").val(),
                        Country: $("input[name='country']").val(),
                        //State: $("input[name='region']").val(),
                        AddressType: "bo_BillTo"
                    };

                    var shippingAddr = {
                        AddressName: "Default Shipping Address",
                        Street: $("input[name='street-address']").val() + ' ' + $("input[name='street-address-2']").val(),
                        ZipCode: $("input[name='zipcode']").val(),
                        City: $("input[name='city']").val(),
                        Country: $("input[name='country']").val(),
                        //State: $("input[name='region']").val(),
                        AddressType: "bo_ShipTo"
                    };

                    var bp = {
                        EmailAddress: $("input[name='contact-email']").val(),
                        FederalTaxID: $("input[name='tax-id-number']").val(),
                        //U_DST_Gross_Purc: $("input[name='last-annual-sales']").val(),
                        Phone1: $("input[name='company-phone']").val(),
                        BPAddresses: [ billingAddr, shippingAddr],
                        ContactEmployees: formsData,
                        U_DST_Gross_Purc: $("input[name='last-annual-sales']").val().replace("USD $", "").replace(",", "")
                    };

                    var myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                      
                    var raw = JSON.stringify(bp);

                    console.log("update");
                    console.log(raw);
                  
                    var requestOptions = {
                      method: 'POST',
                      headers: myHeaders,
                      body: raw
                    };
                    
                    fetch("https://distritech-3f2e5c33550b.herokuapp.com/api/updatebpfromregister2", requestOptions)
                      .then(response => response.json())
                      .then(result => {
                          console.log(result);
                          console.log("CardCode", result.CardCode);

                          //wrapper.body = wrapper.body + "<br><br>CardCode: <b>" + result.CardCode + "</b>";
                          createWcxCase(wrapper);
                          //location.reload();
                      })
                      .catch(error => console.log('error', error));  

                  
                } else {
                    createWcxCase(wrapper);
                }
                
            } else {
                console.log("invalid");
                Toastify({
                  text: "Please complete all the required fields in the form before submitting",
                  style: {
                    background: "#ffcccc",
                    color: "#000"
                  },
                  close: true,
                  position: 'center',
                  gravity: "bottom",
                  offset: {
                    y: 50 // vertical axis - can be a number or a string indicating unity. eg: '2em'
                  }
                }).showToast();
            }
    }

    function validateFrm(selector){
        var isValid = true;
        
        $(selector).each(function(){
            var val = $(this).val();
            console.log("type", $(this).attr("type"));
            if(val == null || val.trim().length == 0 || val == 'Seleccione' || val == 'Please select'){
                isValid = false;
                $(this).addClass("input--error");
            } else {
                if($(this).attr("type") == "email"){
                  var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                  if(!regex.test(val)) {
                      $(this).addClass("input--error");
                      isValid = false;
                  } else {
                    $(this).removeClass("input--error");    
                  }
                } else {
                  if($(this).hasClass("phone-numb")){
                      console.log("itis", itis);
                      var id = $(this).attr("id");
                      var input = document.querySelector('#' + id);
                      //var iti = window.intlTelInputGlobals.getInstance(input);
                      var iti = itis[id];
                      var validNumber = iti.isValidNumber();

                      if(!validNumber){
                          $(this).addClass("input--error");
                          isValid = false;
                      } else {
                          $(this).removeClass("input--error");    
                      }
                    
                  } else {
                      $(this).removeClass("input--error");    
                  }
                  
                }
            }
        });
        
        return isValid;
    }

    function getValueFromMultioptions(selector){
        
        var name = $(this).attr("data-name");
        var id_opt = $(selector).attr("data-multiple");
        var values = '';
        $('.' + id_opt +':checked').each(function(){ 
            if (values != '') {
                values += ', ';
            }
            if($(this).val() == "other_opt"){
                var input_id = $(this).attr("data-input");
                values += $("#" + input_id).val();
            } else {
              values += $(this).val();
            }
        });

        return values;
    }

    function validatePhoneNumber(selector){
         var isValid = true;
      
         $(selector).each(function(){
             $(this).removeClass("input--error");
             if($(this).val().length > 0){
                var id = $(this).attr("id");
                var input = document.querySelector('#' + id);
                //var iti = window.intlTelInputGlobals.getInstance(input);
                var iti = itis[id];
                var validNumber = iti.isValidNumber();

                if(!validNumber){
                    $(this).addClass("input--error");
                    isValid = false;
                } else {
                    $(this).removeClass("input--error");    
                }
             }
         });

         return isValid;
    }

    function validateNumberField(selector){
        var isValid = true;
      
         $(selector).each(function(){
             $(this).removeClass("input--error");
             if($(this).val().length > 0){
                var minAttr = $(this).attr("min");
                var minValue = parseInt(minAttr);
                 var currentValue = parseInt($(this).val());

                if(currentValue < minValue){
                    $(this).addClass("input--error");
                    isValid = false;
                } else {
                    $(this).removeClass("input--error");    
                }
             }
         });

         return isValid;
    }

    function validateFrmCheckebox(selector){
        var isValid = true;
        
        $(selector).each(function(){
            var val = $(this).val();
        
            if(!$(this).is(':checked')){
                isValid = false;
                $(this).addClass("input--error");
            } else {
                $(this).removeClass("input--error");
            }
        });
        
        return isValid;
    }

    function createWcxCase(wrapper){
        $.ajax({
            url: "http://distritech-pdf.azurewebsites.net/api/wcx",
            type: "POST",
            data: JSON.stringify(wrapper),
            contentType: "application/json;charset=utf-8",
            success: function (data) {
                if (data != null ) {
                    console.log("resultado wcx");
                    console.log(data);

                    if(template == "page.register"){
                        sendDataLayer({"eventType": "complete-register-form", "step": "1"});
                    } else if (template == "page.register2"){
                        sendDataLayer({"eventType": "complete-register-form", "step": "2"});
                    } else if (template == "product"){
                        sendDataLayer({"eventType": "request-sale-quotation", "sku": "{{ current_variant.sku }}"});
                    }
                    
                    console.log("redirect_after_save", redirect_after_save);

                    if(redirect_after_save){
                      $('#contact_form_dynamic .fld').each(function(){
                        if($(this).css('display') != 'none'){
                            var name = $(this).attr('data-name');
                            var val = $(this).val();
    
                            if($(this).hasClass("phone-numb")){
                                var id = $(this).attr("id");
                                var input = document.querySelector('#' + id);
                                //var iti = window.intlTelInputGlobals.getInstance(input);
                                var iti = itis[id];
                                val = iti.getNumber();
                            }
    
                            //body += '<tr><td style="border: 1px solid #000; padding: 5px">' + name + '</td><td style="border: 1px solid #000; padding: 5px;">' + val + '</td></tr>';
                            redirect_url = redirect_url.replace("#" + name.toLowerCase() + "#", val);
                        }
                      });
                      console.log("redirect_url")
                      location.href = redirect_url;
                    } else {
                        
                        var json = JSON.parse(data);
                        clear('#contact_form_dynamic input');
                        clear('#contact_form_dynamic textarea');
                        clearSelect('#contact_form_dynamic select');
                        if(myDropzone){
                          myDropzone.removeAllFiles();
                        }
                        hideLoading();
                      
                        Swal.fire({
                            icon: 'success',
                            title: titleMsg,
                            text: responseMsg,
                            showConfirmButton: true
                        });  
                    }

                }
                else {
                    hideLoading();
                    alert("Error creación");
                    //$("#"+id+"Loading").hide();
                    //$("#"+id).show();
                }
            },
            error: function (msg) {
                
                var responseText = msg.responseText;
                hideLoading();
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: responseText 
                });
            }
        });
    }

    function clear(selector){
        $(selector).each(function(){
            //var val = $(this).val();
        
            $(this).val("");
        });
    }

    function clearSelect(selector){
        $(selector).each(function(){
            //var val = $(this).val();
        
            $(this).val("Seleccione");
        });
    }

    function toggleField(selector, show){
        if(show){
            $(selector).show();
            $(selector).addClass("required");
        } else {
            $(selector).hide();
            $(selector).removeClass("required");
        }
    }

    function initSapCountrySelect(){
        //fetch('https://distritech-3f2e5c33550b.herokuapp.com/api/countries')
        fetch('https://distritech-3f2e5c33550b.herokuapp.com/api/groups')
        .then(response => response.json())
        .then(data => {
              const select = $('.sap_country');
              data.forEach(item => {
                const option = $('<option>', {
                  value: item.Code,
                  text: item.Name
                });
                select.append(option);
              });
        });
    }

    function initDropZone(selector, selectorHidden, templateSelector, previewSelector){

         var previewNode = document.querySelector(templateSelector), // Dropzone template holder
                    warningsHolder = $('#warnings'); // Warning messages' holder

        previewNode.id = '';

        var previewTemplate = previewNode.parentNode.innerHTML;
        previewNode.parentNode.removeChild(previewNode);

        //Dropzone.prototype.defaultOptions.dictInvalidFileType = "Imagen no valida, por favor verifica e intenta nuevamente";
        myDropzone = new Dropzone(selector, {
            paramName: 'file',
            //acceptedFiles: 'image/*',
            maxFiles: 10,
            clickable: true,
            maxFilesize: 4,
            uploadMultiple: true,
            addRemoveLinks: true,  
            autoProcessQueue: false,
            previewTemplate: previewTemplate,
            previewsContainer: previewSelector,  
            url: 'https://calidadvisual.azurewebsites.net/api/file',
            //url: "https://calidadvisual.azurewebsites.net/api/file",
            dictDefaultMessage: "Choose file or drag here",
            maxfilesexceeded: function (file) {
                this.removeAllFiles();
                this.addFile(file);
            },
            accept: function (file, done) {
                ext = getExt(file.name);
                console.log("file", file);
                let reader = new FileReader();
                reader.readAsDataURL(file);
    
                reader.onload = function () {
                    var data = reader.result;

                    if(data == null){
                      return;
                    }
                  
                    var n = data.indexOf("base64,");
                    data = data.substring(n + 7);
    
                    console.log("data file from local v5");
                    
                    var succed = "dz-success dz-complete";
    
                    //$(selectorHidden).val(data);
                    //$(selectorHidden).attr("data-filename", file.name);
                    files_to_upload.push({
                        uuid: file.upload.uuid,
                        filename: file.name,
                        dataUrl: data
                    });
    
                    console.log("files");
                    console.log(files_to_upload);
                    
                    $(selector + " .dz-preview").css("margin-left", "40px");
                    $(selector + " .dz-preview").addClass(succed);
    
                    //uploadfile(data, ext, selector, selectorHidden);
                };
    
                done();
            },
            removedfile: function(file) {
                console.log('removedfile triggered');
                console.log(file);
                //this.removeFile(file);
                file.previewElement.remove();
            },
            dictFileSizeUnits: { tb: 'TB', gb: 'GB', mb: 'MB', kb: 'KB', b: 'b' },
            dictRemoveFile: "REMOVE"
        });

        myDropzone.on('addedfile', function (file) {
            $('.preview-container').css('visibility', 'visible');

            var fileTyp = fileType(file.name);
            var commonTypes = "xls xlsx doc docx pdf ppt png svg jpg jpeg";

            if(!commonTypes.includes(fileTyp)){
                fileTyp = "unknown";
            }

            file.previewElement.classList.add('type-' + fileTyp); // Add type class for this element's preview
          
            
            });

      myDropzone.on('totaluploadprogress', function (progress) {
          var progr = document.querySelector('.progress .determinate');
      
          if (progr === undefined || progr === null) return;
      
          progr.style.width = progress + '%';
      });
      
      myDropzone.on('dragenter', function () {
          $(target).addClass('hover');
      });
      
      myDropzone.on('dragleave', function () {
          $(target).removeClass('hover');
      });
      
      myDropzone.on('drop', function () {
          $(target).removeClass('hover');
      });
      
      myDropzone.on('addedfile', function () {
          // Remove no files notice
          $('.no-files-uploaded').slideUp('easeInExpo');
      });
      
      myDropzone.on('removedfile', function (file) {
          // Show no files notice
          if (dropzoneCount() == 0) {
              $('.no-files-uploaded').slideDown('easeInExpo');
              $('.uploaded-files-count').html(dropzoneCount());
          }
      });
      
      myDropzone.on('success', function (file, response) {
          let parsedResponse = JSON.parse(response);
          file.upload_ticket = parsedResponse.file_link;
      
          // Make it wait a little bit to take the new element
          setTimeout(function () {
              $('.uploaded-files-count').html(dropzoneCount());
              console.log('Files count: ' + dropzoneCount());
          }, 350);
      
          // Something to happen when file is uploaded, like showing a message
          if (typeof parsedResponse.info !== 'undefined') {
              console.log(parsedResponse.info);
              warningsHolder.children('span').html(parsedResponse.info);
              warningsHolder.slideDown('easeInExpo');
          }
      });

      dropzones.push(myDropzone);

        /*
        myDropzone.on("removedfile", function(file){
            console.log('remove triggered');
            console.log(file);
        });
      */
    }

    function dropzoneCount() {
                var filesCount = $('#previews > .dz-success.dz-complete').length;
                return filesCount;
            }

    function fileType(fileName) {
                var fileType = /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName) : undefined;
                return fileType[0];
            }

    function  getExt(name) {
        var parts = name.split(".");
        var size = parts.length;

        if (size >= 2) {
            return parts[size - 1];
        }
        else {
            return null;
        }
    }

    function uploadfile(data, ext, selector, selectorHidden) {
        var wr = {
            Ext: ext,
            Data: data
        };

        url = "https://calidadvisual.azurewebsites.net/api/file";
        method = "POST";

        var ajax = $.ajax({
            url: url,
            type: method,
            data: JSON.stringify(wr),
            contentType: "application/json;charset=utf-8",
            success: function (url) {
                var succed = "dz-success dz-complete";
                console.log(url);
                $(selectorHidden).val(url);
                $(selector + " .dz-preview").css("margin-left", "40px");
                $(selector + " .dz-preview").addClass(succed);
            },
            error: function (msg) {
                var error = "dz-error dz-complete";

                imageUrl = "";
                thumbnailUrl = "";
                $(selector + " .dz-preview").css("margin-left", "40px");
                $(selector + " .dz-preview.dz-image-preview").addClass(error);
            }
        });

        return ajax;
    };

    function showLoading() {

        // console.log("loading");
        // var div = document.getElementById("ctnSpinner"); //Capturo el contenedor del spinner
        // div.style.display = "block"; // Hacer visible
        $('body').addClass("loading");
    }

    function hideLoading() {

        // console.log("stop loading");
        // var div = document.getElementById("ctnSpinner"); //Capturo el contenedor del spinner
        // div.style.display = "none"; // Hacer invisible
        $('body').removeClass("loading");
    }

    function prefillFields(){
        console.log("prefillFields");
        // Parse the query string from the URL
        const queryString = window.location.search;
        
        // Create a URLSearchParams object from the query string
        const urlParams = new URLSearchParams(queryString);
        
        // Create an object to store the parameters
        const params = {};
        
        // Loop through all the parameter entries and add them to the object
        for (const [key, value] of urlParams.entries()) {
          const inputElement = $(`input[name="${key}"]`);
          if(inputElement){
             inputElement.val(value);   
          }
        }

    }


  } catch(e) { console.error(e); }
})();
})();
